/**
 * Se definen los roles de la plataforma
 */
export const roles = {
    Admin: "Administrador",
    Operador: "Operador",
    Barista: "Barista",
    Auditor: "Auditor",
    Asesor: "Asesor"
}